import React, { useState, useEffect } from "react";
import axios from "axios";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import {
  Container,
  Typography,
  List,
  ListItem,
  ListItemText,
  IconButton,
  CircularProgress,
  Paper,
  Box,
  Button,
  Snackbar,
  Alert,
  Divider,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { useNavigate } from "react-router-dom";
import backgroundImg from "../../../assets/ImgFundo/fundo-abstratoC.jpg";
import MediaUploadField from "../MediaUploadField";

const modules = {
  toolbar: [
    [{ font: [] }],
    [{ header: "1" }, { header: "2" }],
    [{ list: "ordered" }, { list: "bullet" }],
    ["bold", "italic", "underline", "strike"],
    [{ color: [] }, { background: [] }],
    [{ align: [] }],
    ["link", "image", "blockquote", "code-block"],
    ["clean"],
  ],
};

const GerenciarArtigos = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();

  const [artigos, setArtigos] = useState([]);
  const [selectedArtigo, setSelectedArtigo] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [alertMessage, setAlertMessage] = useState({ type: "", text: "" });
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchArtigos();
  }, []);

  const fetchArtigos = async () => {
    try {
      const response = await axios.get(`${apiUrl}/artigos`);
      console.log("Dados dos artigos:", response.data); // Verifique se a URL da imagem está correta

      setArtigos(response.data);
      setLoading(false);
    } catch (error) {
      console.error("Erro ao buscar artigos:", error);
      setLoading(false);
    }
  };

  const handleEditClick = (artigo) => {
    setSelectedArtigo(artigo);
    setOpenDialog(true);
  };

  const handleDeleteArtigo = async (id) => {
    const token = localStorage.getItem("token");
    if (!token) {
        setAlertMessage({ type: "error", text: "Você precisa estar autenticado para excluir um artigo." });
        setOpenSnackbar(true);
        return;
    }

    try {
        await axios.delete(`${apiUrl}/artigos/${id}`, {
            headers: { Authorization: `Bearer ${token}` }, // Incluindo o token no cabeçalho
        });
        setAlertMessage({ type: "success", text: "Artigo excluído com sucesso!" });
        fetchArtigos();
    } catch (error) {
        console.error("Erro ao excluir o artigo:", error.response?.data || error.message);
        setAlertMessage({ type: "error", text: "Erro ao excluir o artigo." });
    }
    setOpenSnackbar(true);
};


const handleInputChange = (e) => {
  const { name, value } = e.target;
  setSelectedArtigo((prev) => ({
      ...prev,
      [name]: value, // Isso garante que apenas o campo editado é alterado
  }));
};
const setSelectedField = (name, value) => {
  setSelectedArtigo((prev) => ({ ...prev, [name]: value }));
};
const handleUploadError = (message) => {
  setAlertMessage({ type: "error", text: message });
  setOpenSnackbar(true);
};
const handleUploadSuccess = (message) => {
  setAlertMessage({ type: "success", text: message });
  setOpenSnackbar(true);
};

  const handleQuillChange = (value) => {
    setSelectedArtigo((prev) => ({ ...prev, conteudo: value }));
  };

  const handleSaveChanges = async () => {
    const token = localStorage.getItem("token");
    if (!token) {
      setAlertMessage({ type: "error", text: "Você precisa estar autenticado para editar um artigo." });
      setOpenSnackbar(true);
      return;
    }

    try {
      await axios.put(`${apiUrl}/artigos/${selectedArtigo._id}`, selectedArtigo, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setAlertMessage({ type: "success", text: "Artigo atualizado com sucesso!" });
      fetchArtigos();
      setOpenDialog(false);
    } catch (error) {
      setAlertMessage({ type: "error", text: "Erro ao atualizar o artigo." });
    }
    setOpenSnackbar(true);
  };

  return (
    <div
    style={{
        padding: '20px',
        backgroundImage: `url(${backgroundImg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        minHeight: '100vh',
        color: 'white', // Para garantir que o texto tenha boa visibilidade
    }}
>  
    <Box sx={{ p: 3 }}>
      <hr style={{ margin: "40px 0", borderTop: "1px solid #ddd" }} />
      <hr style={{ margin: "40px 0", borderTop: "1px solid #ddd" }} />

      <Typography
        variant="h2"
        align="center"
        gutterBottom
        style={{
          fontFamily: "'Lato', serif",
          color: "#800020",
          textShadow: "2px 2px 4px rgba(0, 0, 0, 0.5)",
          borderBottom: "4px solid #d4af37",
          paddingBottom: "10px",
          textTransform: "uppercase",
          animation: "glow 2s infinite alternate",
          marginTop: "7%",
        }}
      >
        Lista de Matérias
      </Typography>

      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
          <CircularProgress />
        </Box>
      ) : (
        <List sx={{ backgroundColor: "#f4f6f8", borderRadius: 2, boxShadow: 1 }}>
          {artigos.map((artigo) => (
            <Paper key={artigo._id} sx={{ marginBottom: 2, padding: 2, borderRadius: 1, boxShadow: 1 }}>
              <ListItem
                secondaryAction={
                  <>
                    <IconButton edge="end" aria-label="edit" onClick={() => handleEditClick(artigo)}>
                      <EditIcon />
                    </IconButton>
                    <IconButton edge="end" aria-label="delete" onClick={() => handleDeleteArtigo(artigo._id)}>
                      <DeleteIcon />
                    </IconButton>
                  </>
                }
              >
                <ListItemText
                  primary={<Typography variant="h6">{artigo.titulo}</Typography>}
                  secondary={<Typography variant="body2" color="textSecondary">Data de Criação: {new Date(artigo.dataCriacao).toLocaleDateString()}</Typography>}
                />
              </ListItem>
              <Divider />
            </Paper>
          ))}
        </List>
      )}

      <Box sx={{ display: "flex", justifyContent: "flex-end", marginTop: 3 }}>
        <Button
          variant="contained"
          color="primary"
          onClick={() => navigate("/PainelDeControle/DashBoardArtigos")}
          sx={{ padding: "10px 20px", fontSize: "16px" }}
        >
          Adicionar Novo Artigo
        </Button>
      </Box>

      {/* Modal de Edição */}
      <Dialog open={openDialog} onClose={() => setOpenDialog(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Editar Artigo</DialogTitle>
        <DialogContent>
          <TextField fullWidth label="Título" name="titulo" value={selectedArtigo?.titulo || ""} onChange={handleInputChange} margin="normal" />
          <MediaUploadField
            label="Imagem do artigo"
            name="imagens"
            value={selectedArtigo?.imagens?.[0] || ""}
            onChange={(name, value) => setSelectedField(name, [value])}
            folder="artigos"
            accept="image/*"
            onError={handleUploadError}
            onSuccess={handleUploadSuccess}
          />
          <MediaUploadField
            label="Arquivo para Download"
            name="arquivoDownload"
            value={selectedArtigo?.arquivoDownload || ""}
            onChange={setSelectedField}
            folder="artigos"
            accept=".pdf,application/pdf"
            onError={handleUploadError}
            onSuccess={handleUploadSuccess}
          />
          <Typography variant="body1" gutterBottom>Conteúdo do Artigo:</Typography>
          <ReactQuill value={selectedArtigo?.conteudo || ""} onChange={handleQuillChange} modules={modules} />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialog(false)} color="secondary">
            Cancelar
          </Button>
          <Button onClick={handleSaveChanges} color="primary">
            Salvar
          </Button>
        </DialogActions>
      </Dialog>

      {/* Alerta Snackbar */}
      <Snackbar open={openSnackbar} autoHideDuration={6000} onClose={() => setOpenSnackbar(false)}>
        <Alert severity={alertMessage.type}>{alertMessage.text}</Alert>
      </Snackbar>
    </Box>
    </div>
  );
};

export default GerenciarArtigos;
